import React,{ createContext, useState } from "react";

interface Client {
    cep: string,
    number: string,
    street: string,
    state: string,
    city: string,
    neighborhood: string,
    complement: string,
    days: string,
    hours: string,
    name: string,
}

interface ClientContextProps {
    client: Client | null,
    setClient: React.Dispatch<React.SetStateAction<Client | null>>
}

export const ClientContext = createContext<ClientContextProps>({
    client:{
        cep: '',
            number: '',
            street: '',
            state: '',
            city: '',
            neighborhood: '',
            complement: '',
            days: '',
            hours: '',
            name: ''
    },
    setClient: ()=>{return}
})

export const ClientProvider: React.FC<any> = ({children})=>{
    const [client, setClient] = useState<Client | null>(null)

    return (
        <ClientContext.Provider value={{ client, setClient }}>
            {children}
        </ClientContext.Provider>
    );
}